import React, { FC } from 'react';
import { DateField, Text } from '@sitecore-jss/sitecore-jss-react';
import { THeadingTag, TSitecoreContext } from '../../../../types/types';
import { TImageField } from '../../../../types/sitecore.types';
import { TLatestNewsCardItemProps } from '../../types/latestNews.types';
import { NewsCardModel } from './models/newsCard.model';
import CTA from '../../../@shared/CTA';
import ctaTypes from '../../../../enums/CTA.enums';
import DictionaryTerm from '../../../@shared/dictionaryTerm';
import useMediaQuery from '../../../../hooks/useMediaQuery';
import breakpoints from '../../../../constants/breakpoints.constants';
import Media from '../media';
import useFormatDate from '../../../../hooks/useFormatDate';
import './styles.scss';

const NewsCard: FC<{
  item: TLatestNewsCardItemProps;
  cardHeadingTitleTag: THeadingTag;
  sitecoreContext: TSitecoreContext;
  defaultCardImage?: TImageField;
}> = ({ item, cardHeadingTitleTag, sitecoreContext, defaultCardImage }): JSX.Element => {
  const model = new NewsCardModel(item, sitecoreContext);
  const isWide = useMediaQuery(`(min-width: ${breakpoints['tbl-l']}px)`);
  const formattedDate = useFormatDate(model.newsDate?.value);

  return (
    <article className="latest-news-card">
      {model?.tag?.value && (
        <div className={'latest-news-card__tag'}>
          <Text field={model?.tag} tag={'div'} editable={false} className={'latest-news-card__tag--text'} />
        </div>
      )}

      <Media
        desktopImage={model?.image}
        mobileImage={model?.mobileImage}
        isDesktop={isWide}
        useVideo={model?.showVideo}
        videoUrl={model?.video}
        defaultImage={defaultCardImage}
      />
      <div className="latest-news-card__content--wrapper">
        <div className="latest-news-card__content--body">
          {model?.newsDate && (
            <DateField
              field={model.newsDate}
              tag="div"
              className="latest-news-card__content--date"
              render={() => formattedDate}
              editable={false}
            />
          )}
          {model?.title && (
            <Text field={model?.title} tag={cardHeadingTitleTag} className="latest-news-card__content--title" editable={false} />
          )}
          {model?.shortDescription && (
            <Text field={model?.shortDescription} tag={'div'} className="latest-news-card__content--description" editable={false} />
          )}
        </div>

        <div className="latest-news-card__content--button">
          {model?.ctaLink && (
            <CTA type={ctaTypes.primaryOrange} href={model.ctaLink}>
              <DictionaryTerm keyword="cnhi-readMore" />
            </CTA>
          )}
        </div>
      </div>
    </article>
  );
};

export default NewsCard;
